// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.num-destac[data-v-25d4c19a] {\nfont-weight: 600;\nfont-size: 24px;\n}\n.swal2-container[data-v-25d4c19a] {\nz-index: 9999999 !important;\n}\n.cursor[data-v-25d4c19a]{\n    cursor: pointer;\n}\n.responsive-mobile[data-v-25d4c19a] {\n  display: none;\n}\n@media screen and (max-width: 820px) {\n.responsive-mobile[data-v-25d4c19a] {\n    display: flex;\n}\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
